import React from "react";

const WORDS = ["Immersion", "Émotion", "Immobilier", "Mode & Luxe", "Corporate", "Innovation"];

const Marquee = () => (
  <div data-testid="marquee" className="py-10 border-y border-white/10 overflow-hidden select-none">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center">
          {WORDS.map((w) => (
            <span key={w + k} className="flex items-center">
              <span className="font-serif italic text-5xl lg:text-7xl text-[#F5F5F0] px-8">{w}</span>
              <span className="text-[#D4AF37] text-2xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
